import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Glyphs } from '../../../../rapid-ui'

export type LayerManagerProps = {
	contentLayerControls: ReactNode
	backdropLayerControls: ReactNode
}

export function LayerManager({
	contentLayerControls,
	backdropLayerControls,
}: LayerManagerProps) {
	const { t } = useTranslation('common')
	return (
		<div>
			<div className="flex items-center gap-2 pt-0 pb-2 pl-6">
				<div className="grow-1" />
				{
					/* <Button size="inline" type="subtle">
					Add text
				</Button> */
				}
			</div>
			<div>
				<ContentLayerItem
					name={t('editor.layerManager.content')}
					controls={contentLayerControls}
				/>
				<BackdropLayerItem
					name={t('editor.layerManager.backdrop')}
					controls={backdropLayerControls}
				/>
			</div>
		</div>
	)
}

type LayerItemProps = {
	name: ReactNode
	type: 'backdrop' | 'content' | 'text' | 'shape'
}

function LayerItem({ name }: LayerItemProps) {
	return (
		<div className="flex items-center gap-2 text-sm py-2 px-1 border-t border-gray-100">
			<Glyphs.core.LayerIcon />
			{name}
		</div>
	)
}

type ContentLayerItemProps = {
	name: ReactNode
	controls: ReactNode
}

function ContentLayerItem(
	{ name, controls }: ContentLayerItemProps,
) {
	return (
		<>
			<div className="flex items-center gap-2 text-sm py-2 px-1 border-t border-gray-100">
				<Glyphs.core.LayerIcon />
				{name}
			</div>
			<div className="ml-10 mb-4">{controls}</div>
		</>
	)
}

type BackdropLayerItemProps = {
	name: ReactNode
	controls: ReactNode
}

function BackdropLayerItem(
	{ name, controls }: BackdropLayerItemProps,
) {
	return (
		<>
			<div className="flex items-center gap-2 text-sm py-2 px-1 border-t border-gray-100">
				<Glyphs.core.LayerIcon />
				{name}
			</div>
			<div className="mb-4">{controls}</div>
		</>
	)
}
